//import {Dropdown} from "bootstrap" 

const header = document.querySelector('header');
const openButton = document.querySelector('.navbar-open');
const closeButton = document.querySelector('.navbar-close');
const body = document.querySelector('body');
const blogBar = document.querySelector('.blog-bar');
const primaryBar = document.querySelector('.primary-bar');
const $ = jQuery;

if(header.classList.contains('type-ee')) {

    openButton.addEventListener('click', function() {
        body.classList.add('menu-opened');
        blogBar.classList.add('open');
        primaryBar.classList.add('open');
        closeButton.classList.remove('d-none');
        this.classList.add('d-none');
    });
    
    closeButton.addEventListener('click', function() {
        body.classList.remove("menu-opened");
        blogBar.classList.remove("open");
        primaryBar.classList.remove("open");
        openButton.classList.remove('d-none');
        this.classList.add('d-none');
    });
    
}

if(header.classList.contains('type-eu')) {

    const drops = document.querySelectorAll('header.type-eu .dropdown');
    const desktopMediaQuery = window.matchMedia('(min-width: 1280px)');
    

    drops.forEach((drop) => {
        handleDropdown(drop, desktopMediaQuery);
    });

    openButton.addEventListener('click', function() {
        body.classList.add('menu-opened');
        header.classList.add('open');
    });

    closeButton.addEventListener('click', function() {
        body.classList.remove('menu-opened');
        header.classList.remove('open');
    });

    handleScroll();

}

function handleScroll(){
    const header = document.querySelector('header.type-eu');
    let lastScrollPosition = window.pageYOffset;

    window.addEventListener('scroll', function() {
        
        if(window.pageYOffset > header.offsetTop) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        if(!header.classList.contains('new')) {
            if (lastScrollPosition < window.pageYOffset && window.pageYOffset > 200 ) {
                header.classList.add('scroll-down');
                lastScrollPosition = window.pageYOffset;
            } else if (lastScrollPosition - 150 > window.pageYOffset || window.pageYOffset < 200) {
                header.classList.remove('scroll-down');
                lastScrollPosition = window.pageYOffset;
            }
        } 

        console.log (lastScrollPosition);

    });
}



function handleDropdown(el, isDesktop) {

    let dropDownToggle = el.querySelector('.dropdown-toggle');
    let dropDownMenu = el.querySelector('.dropdown-menu');
    let navLink = el.querySelector('.nav-link');

    el.addEventListener('mouseenter', () => {
        if (isDesktop.matches) {
            if(!dropDownMenu.classList.contains('show')){
                $(dropDownToggle).dropdown('show');
            }
        }
    });

    el.addEventListener('mouseleave', () => {
        if (isDesktop.matches) {
            if(dropDownMenu.classList.contains('show')){
                $(dropDownToggle).dropdown('hide');
            }
        }
    });

    if(navLink) {
        navLink.addEventListener('click', (event) => {
            if (!isDesktop.matches) {
                event.preventDefault();
                event.stopPropagation();
                $(dropDownToggle).dropdown('toggle');
            }
        });
    }

}